exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ui.inverted.dimmer>.content>*{color:#000 !important}.ErrorPage__header___k7uGd{margin-bottom:2rem !important;max-width:20em}", "", {"version":3,"sources":["/opt/TeamCity/buildAgentTest/work/87d7e5c6c6455c0d/packages/common/components/errorPage/ErrorPage.scss"],"names":[],"mappings":"AAAA,+BACE,qBAAA,CAGF,2BACE,8BACA,cAAA,CAAA","file":"ErrorPage.scss","sourcesContent":[":global(.ui.inverted.dimmer>.content>*) {\n  color: black !important;\n}\n\n.header {\n  margin-bottom: 2rem !important;\n  max-width: 20em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "ErrorPage__header___k7uGd"
};